<template>
  <section>
    <h2> 整数 a,b を入力 </h2>
    <div class="math">
      a <span class="equal"> =  </span>
      <input type="text" :class="{error: a_error}" v-model.number="a"/>
    </div>
    <div class="math">
      b <span class="equal"> =  </span>
      <input type="text" :class="{error: b_error}" v-model.number="b"/>
    </div>
    <p v-if="! error">
      <button class="exec" @click="set">決定</button>
    </p>
  </section>
</template>

<script>
export default {
  name: 'InputInt',
  data: function(){
    return {
      a: 1,
      b: 1,
    }
  },
  computed: {
    a_error(){
      return this.a == 0 || ! Number.isInteger(this.a)
    },
    b_error(){
      return this.b == 0 || ! Number.isInteger(this.b)
    },
    error(){
      return this.a_error || this.b_error
    }
  },
  methods: {
    set(){
      this.$emit('finish',this.a,this.b);
    }
  }
}
</script>

<style scoped>
</style>
